import api from '../api';
import {
  FeeTemplateByIdResponse,
  IFeeTemplateDetails,
  IFeeTemplatesResponse,
  IFetchFrequency,
  IGetAssignClassroom,
  IGetFeeTemplateRequestParams,
  IFeeTemplateStudentsResponse,
} from '../../interface/feeTemplateModel';

/**
 * Fetch all fee templates with pagination
 */
export const fetchFeeTemplatesService = async (
  params: IGetFeeTemplateRequestParams,
): Promise<IFeeTemplatesResponse> => {
  const response = await api.get('/payment/feeTemplates', { params });
  return response.data;
};

/**
 * Fetch a single fee template by ID
 */
export const fetchFeeTemplateByIdService = async (id: string): Promise<FeeTemplateByIdResponse> => {
  const response = await api.get(`/payment/feeTemplate/${id}`);
  return response.data;
};

/**
 * Fetch classrooms assigned to a fee template
 */
export const fetchClassroomAssignedToFeeTemplateService = async (
  id: string,
): Promise<IGetAssignClassroom> => {
  const response = await api.get(`/payment/feeTemplate/classroom/${id}`);
  return response.data;
};

/**
 * Update classrooms assigned to a fee template
 */
export const updateClassroomAssignedToFeeTemplateService = async (
  id: string,
  classroomIds: string[],
): Promise<IGetAssignClassroom> => {
  const response = await api.put(`/payment/feeTemplate/classroom/${id}`, {
    classroomIds,
  });
  return response.data;
};

/**
 * Fetch frequency options for fee templates
 */
export const fetchFrequencyService = async (): Promise<IFetchFrequency> => {
  const response = await api.get('/payment/frequency');
  return response.data;
};

/**
 * Create a new fee template
 */
export const createFeeTemplateService = async (
  body: IFeeTemplateDetails,
): Promise<IFetchFrequency> => {
  const response = await api.post('/payment/feeTemplate', body);
  return response.data;
};

/**
 * Update an existing fee template
 */
export const updateFeeTemplateService = async (
  id: string,
  body: IFeeTemplateDetails,
): Promise<IFetchFrequency> => {
  const response = await api.put(`/payment/feeTemplate/${id}`, body);
  return response.data;
};

/**
 * Delete a fee template
 */
export const deleteFeeTemplateService = async (id: string): Promise<IFetchFrequency> => {
  const response = await api.delete(`/payment/feeTemplate/${id}`);
  return response.data;
};

/**
 * Fetch students by fee template ID
 */
export const fetchStudentsByFeeTemplateService = async (
  feeTemplateId: string,
): Promise<IFeeTemplateStudentsResponse> => {
  const response = await api.get(`/payment/feeTemplate/${feeTemplateId}/students`);
  return response.data;
};
